import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f2c2919"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "live-card-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-guanbibeifen1" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-guanbibeifen1" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  style: {"margin-bottom":"12px"}
}

import { onMounted, reactive, ref, computed } from 'vue'
import { requestVideoGetActivities } from '@/apis/live'
import { shopOrderCount } from '@/apis/order'
import LiveCard from './LiveCard/index.vue'
import { useStore } from 'vuex'
import useUserConfig, { ENUM_CONFIG_CODE } from '@/util/useUserConfig'

export interface ActivityItem {
  activityId: string;
  name: string;
  coverImage: string;
  /** 1：直播中 2：预告 3：回放 4：停止 */
  status: number;
  enablePeopleCount: number;
  uv: string;
  liveTime: string;
  viewUrl: string;
  token: string;
  reserveFlag: number;
  pcHeaderImageUrl: string;
  pcBackImageUrl: string;
  pcBackImageUrlDefault: string;
}

interface ReactiveData {
  activities?: {
    /** 播完回放的 */
    backActivities: ActivityItem[];
    /** 正在播放的 */
    livingActivities: ActivityItem[];
    /** 不在播放的且需要预约的 */
    reserveActivities: ActivityItem[];
  };
}

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const [getLineValue, setLineValue] = useUserConfig(ENUM_CONFIG_CODE.LINE_MODAL)
const store = useStore()
const showLine = ref(true)
const showEdu = ref(true)
const isOldCustomer = ref(false)
const videoGetActivitiesData = reactive<{ activities?: { reserveAndLivingActivities: ActivityItem[]; } }>({
  activities: undefined
})
const gotoLine = () => window.open('https://lin.ee/9noQAY4')
const gotoEdu = () => window.open('https://static-jp.theckb.com/static-asset/client/【初心者向け】15分以内で分かる　THE直行便システム利用方法完全解説！.mp4')
// 新会员入会活动
const newMemberActivity = computed(() =>
  store.state.status?.newMemberActivity?.id
    ? store.state.status.newMemberActivity
    : false
)

// 是否有会员续费活动
const renewalMemberActivity = computed(() => {
  return store.getters.user?.membership?.templateLevel < 1
})
const judgeOldCustomer = async () => {
  if (!store.getters.curShop) return
  if (!store.getters.isLogin) return
  const res = await shopOrderCount({
    customerShopId: store.getters.curShop
  })
  if (res.data && Number(res.data) > 0) {
    isOldCustomer.value = true
  }
}
const isLogin = computed(() => store.getters.isLogin)
const membership = computed(() => store.getters.user?.membership)
onMounted(async () => {
  judgeOldCustomer()
  const res = await requestVideoGetActivities()

  const newActivitiesData = (() => {
    const resData = res.data as ReactiveData['activities']
    const reserveActivities:any[] = resData?.reserveActivities ?? []
    const livingActivities:any[] = resData?.livingActivities ?? []
    // 未登录不展示回放视频并且有会员才展示
    const backActivities:any[] = (membership.value?.templateLevel > 0 && isLogin) ? resData?.backActivities ?? [] : []
    reserveActivities.forEach(item => {
      item.cardType = 'reserve'
    })
    livingActivities.forEach(item => {
      item.cardType = 'play'
    })
    backActivities.forEach(item => {
      item.cardType = 'play'
    })
    const reserveAndLivingActivities = [...livingActivities, ...reserveActivities, ...backActivities]

    /**
     * 是否可以展示直播 -> 对测试直播的校验(线上和预发环境不展示测试的直播)
     * @param activityItem 直播配置
     */
    const getIsVideoShowValidateTest = (activityItem: ActivityItem) => {
      const liveName = activityItem.name ?? ''
      const isTestLive = liveName.toLocaleLowerCase().includes('_test')
      const isPreOrProd = ['pre-s.theckb.com', 's.theckb.com'].includes(
        window.location.host
      )
      const isTesters = window.location.search.includes('isLive')
      // 测试视频 线上和预发环境 不是测试人员就不展示
      if (isTestLive && isPreOrProd && !isTesters) return false
      return true
    }

    /**
     * 是否可以展示直播 -> 预约卡片对开播时间的校验(开播时间必须大于当前时间)
     * @param activityItem 直播配置
     */
    const getIsVideoShowValidateReservePlayTime = (
      activityItem: ActivityItem
    ) => {
      const itemPlayTime = new Date(
        Number(activityItem.liveTime) * 1000
      ).getTime()
      const currentTime = new Date().getTime()
      return itemPlayTime > currentTime
    }

    const newReserveActivities = reserveActivities.filter((item) => {
      return (
        getIsVideoShowValidateTest(item) &&
        getIsVideoShowValidateReservePlayTime(item)
      )
    })
    return {
      reserveActivities: newReserveActivities,
      reserveAndLivingActivities: reserveAndLivingActivities.filter((item) =>
        getIsVideoShowValidateTest(item)
      )
    }
  })()
  // videoGetActivitiesData.activities = res.data
  videoGetActivitiesData.activities = newActivitiesData
  // debugger
  if (isLogin.value) {
    const val = await getLineValue()
    showEdu.value = val !== '1'
  }
})
const closeModal = async () => {
  if (!isLogin.value) {
    showEdu.value = false
    return
  }
  await setLineValue('1')
  const val = await getLineValue()
  showEdu.value = val !== '1'
}
expose({
  activities: videoGetActivitiesData.activities,
  getIsExistLive: () =>
    Boolean(
      [
        ...(videoGetActivitiesData.activities?.reserveActivities ?? []),
        ...(videoGetActivitiesData.activities?.reserveAndLivingActivities ?? [])
      ].length
    )
})
// requestVideoGetActivities

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass({
        line: true,
        // 244 没直播，且有新会员入会活动
        'bottom-244':
          !Boolean(
            _unref(videoGetActivitiesData).activities?.reserveAndLivingActivities?.length
          ) &&
          !Boolean(
            _unref(videoGetActivitiesData).activities?.reserveActivities?.length
          ) &&
          (_unref(newMemberActivity) || _unref(renewalMemberActivity)),
      })
    }, [
      _createElementVNode("span", {
        class: "close",
        onClick: closeModal
      }, _hoisted_3),
      _createElementVNode("img", {
        onClick: gotoLine,
        src: "https://static-jp.theckb.com/static-asset/client/line.png",
        alt: "line",
        width: "320"
      })
    ], 2), [
      [_vShow, showEdu.value]
    ]),
    (!isOldCustomer.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass({
        line: true,
        // 244 没直播，且有新会员入会活动
        'bottom-244':
          !Boolean(
            _unref(videoGetActivitiesData).activities?.reserveAndLivingActivities?.length
          ) &&
          !Boolean(
            _unref(videoGetActivitiesData).activities?.reserveActivities?.length
          ) &&
          (_unref(newMemberActivity) || _unref(renewalMemberActivity)),
      })
        }, [
          _createElementVNode("span", {
            class: "close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showLine.value = false))
          }, _hoisted_5),
          _createElementVNode("img", {
            onClick: gotoEdu,
            src: "https://static-jp.theckb.com/static-asset/client/edu_cover.png",
            alt: "line",
            width: "320",
            height: "180"
          })
        ], 2)), [
          [_vShow, showLine.value && _unref(isLogin)]
        ])
      : _createCommentVNode("", true),
    (
        Boolean(_unref(videoGetActivitiesData).activities?.reserveAndLivingActivities?.length)
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(LiveCard, {
            idPrefix: "playing",
            activities: _unref(videoGetActivitiesData).activities?.reserveAndLivingActivities ?? []
          }, null, 8, ["activities"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})